import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NbAuthService } from '@nebular/auth';
import { NbSidebarService } from '@nebular/theme';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import * as $ from 'jquery';
import { EntidadService } from 'src/app/services/entidad.service';
import { AuthService } from '../auth/auth.service';
import { Entidad } from '../auth/models/entidad.model';
import { Perfil } from '../services/perfil.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-external',
  templateUrl: './external.component.html',
  styleUrls: ['./external.component.scss']
})
export class ExternalComponent implements OnInit {
  user?: string;

  logoEntidad$: Observable<SafeUrl | null>;
  collapse_side_bar_one: boolean = false;
  mostrarRuta = "";

  constructor(
    sanitizer: DomSanitizer,
    private authService: AuthService,
    private nbAuthService: NbAuthService,
    private entidadService: EntidadService,
    private nbSidebarService: NbSidebarService
  ) {
    this.logoEntidad$ = nbAuthService.onTokenChange().pipe(
      switchMap(() => this.entidadService.getLogoEntidad()),
      map(logo => URL.createObjectURL(logo)),
      map(url => sanitizer.bypassSecurityTrustUrl(url))
    );
  }

  ngOnInit(): void {
    combineLatest([
      this.nbAuthService.getToken().pipe(
        map(token => token.getPayload()),
        filter<any>(Boolean)
      ),
      this.entidadService.getEntidades().pipe(
        filter(entidades => !!entidades),
        map(entidades => entidades || [])
      )
    ]).subscribe(([payload, entidades]) => {
      this.user = payload.name;

      const items = [];
      for (const entidad of entidades) {
      }
    });
  }
}